import { AddressData } from "./GetUsersByDateRangeAsync";
import { getApiBaseUrl } from '../utils/apiBaseUrl'

export const getAddressesByUserIdAsync = async (
  userId: string,
  token: string
): Promise<AddressData[]> => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/Admin/GetAddressesByUserIdAsync?userId=${userId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch addresses: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    // console.error("Error in getAddressesByUserIdAsync:", error);
    throw error;
  }
};
